export enum BulkActionType {
  ASSIGN_DEDICATED_SMS = "ASSIGN_DEDICATED_SMS",
  UNASSIGN_DEDICATED_SMS = "UNASSIGN_DEDICATED_SMS",
  UPDATE_TRACKING_INTERVAL = "UPDATE_TRACKING_INTERVAL",
  MANAGE_GATEWAY_DEVICES = "MANAGE_GATEWAY_DEVICES",
  GATEWAY_DELETE_DEVICES = "GATEWAY_DELETE_DEVICES"
}
